class LkComparisonFilter {
    constructor() {
        this.category = document.querySelector('.js-comparison-category');

        if (!this.category) return;

        this.wrapper = this.category.closest('.js-lk-comparison-wrapper');
        this.activeBtn = this.wrapper.querySelector('[data-comparison-btn]._active');
        this.activeContent = this.wrapper.querySelector('[data-comparison-content]._active');
        this.select = this.wrapper.querySelector('.js-lk-comparison-select');
        this.diffInput = this.wrapper.querySelector('input[name="differences"]');

        this.init();
    }

    init = () => {
        this.category.addEventListener('click', this.onChangeCategory);
        this.diffInput.addEventListener('input', this.onChangeDiff);

        this.onChangeDiff();
    }

    onChangeCategory = (e) => {
        const target = e.target;
        const triggerEl = (
            target.closest('[data-comparison-btn]:not(._active)') ||
            target.closest('.option:not(.selected)')
        );

        if (!triggerEl) return;

        const isSelect = window.innerWidth <= 767;

        if (isSelect) {
            setTimeout(() => {
                const id = this.select.selectedOptions[0].dataset.comparison;

                this.changeContent(id, triggerEl, isSelect);
            })
        } else {
            const id = triggerEl.dataset.comparison;

            this.changeContent(id, triggerEl, isSelect);
        }
    }

    onChangeDiff = () => {
        const isDiff = this.diffInput.checked;

        const activeContent = this.wrapper.querySelector('[data-comparison-content]._active');
        const slider = activeContent.querySelector('.js-comparison-slider');
        const stats = activeContent.querySelector('.js-comparison-characteristics');
        const scrollBoxes = activeContent.querySelectorAll('.js-comparison-scroll-box');
        const contents = activeContent.querySelectorAll('.js-dropdown');

        const activeIndex = slider.swiper.activeIndex;

        stats.style.opacity = 0;

        setTimeout(() => {
            scrollBoxes.forEach(box => {
                const oneEl = box.children[activeIndex];
                const twoEl = box.children[activeIndex + 1];

                if (!oneEl || !twoEl) return;

                if (isDiff && oneEl.innerHTML === twoEl.innerHTML) {
                    box.parentElement.classList.add('_hide');
                } else if (oneEl.innerHTML === '–' && twoEl.innerHTML === '–') {
                    box.parentElement.classList.add('_hide');
                } else {
                    box.parentElement.classList.remove('_hide');
                }
            })

            contents.forEach(item => {
                const stats = item.querySelectorAll('.lk__comparison-characteristic');
                const statsHide = item.querySelectorAll('.lk__comparison-characteristic._hide');

                if (stats.length === statsHide.length) {
                    item.classList.add('_hide');
                } else {
                    item.classList.remove('_hide');
                }
            })

            const showingContents = Array.from(contents).filter(item => !item.classList.contains('_hide'));

            if (showingContents.length === 1) {
                showingContents[0].classList.add('_show');
            } else {
                showingContents.forEach(item => item.classList.remove('_show'));
            }

            stats.style.opacity = 1;
        }, 300)
    }

    changeContent = (id, triggerEl, isSelect) => {
        const content = this.wrapper.querySelector(`[data-comparison="${id}"][data-comparison-content]`);

        if (content) {
            this.activeBtn.classList.remove('_active');
            this.activeContent.classList.remove('_active');

            if (isSelect) {
                triggerEl = this.wrapper.querySelector(`[data-comparison="${id}"][data-comparison-btn]`);
            } else {
                const selectOption = this.wrapper.querySelector(`[data-value="${id}"]`);

                selectOption.click();
            }

            triggerEl.classList.add('_active');
            content.classList.add('_active');

            this.activeBtn = triggerEl;
            this.activeContent = content;

            this.onChangeDiff();
        }
    }
}
